// src\app\components\HomePageTabs.jsx

// react/redux
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

// modules
import { actions as commonActions } from '../modules/commonModule'
import { BASE, PATH, TAB } from "../modules/constants"

// components
import Tabs from "../components/Tabs"
import WhyRegisterModal from "../components/WhyRegisterModal"
import SubscriptionFeatureModal from "../components/SubscriptionFeatureModal"
import UnderDevelopmentModal from "../components/UnderDevelopmentModal"
import { getVisibleTabs } from "../modules/tabDefinitions"

class HomePageTabs extends Component {

  constructor() {
    // console.log("HomePageTabs constructor")
    super()
    this.state = {
      showWhyRegisterModal: false,
      showSubscriptionFeatureModal: false,
    }
  }

  get effectiveFeatures() {
    const { features, the350club } = this.props
    return { ...features, ShowAdvisers: !the350club }
  }

  handleTabsChange = (visualIndex, lseAppts) => {
    // console.log("handleTabsChange this.props:", this.props)
    if (this.tabPermitted(visualIndex, lseAppts)) {
      const visibleTabs = getVisibleTabs(this.effectiveFeatures)
      const tab = visibleTabs[visualIndex]
      const fixedIndex = tab ? TAB[tab.key].INDEX : visualIndex
      this.props.common.changeTab(
        {
          ...this.props,
          index: fixedIndex,
        })
    }
  }

  // Returns the PATH associated with the visible tab at the given visual index
  getPathFromIndex = index => {
    const visibleTabs = getVisibleTabs(this.effectiveFeatures)
    const tab = visibleTabs[index]
    return tab ? tab.path : PATH[BASE.SEARCH]
  }

  tabPermitted = (index, lseAppts) => {
    // console.log("lseAppts: " + lseAppts)
    const visibleTabs = getVisibleTabs(this.effectiveFeatures)
    const key = visibleTabs[index]?.key

    switch (key) {
      case BASE.LSE.COMPANIES:
      case BASE.LSE.ROLES:
      case BASE.LSE.PEOPLE:
      case BASE.LSE.ADVISERS:
      case BASE.LSE.NEWS:
        if (!lseAppts) {
          this.props.common.setLoginUrl({ pathname: this.getPathFromIndex(index) })
          this.setState({ showSubscriptionFeatureModal: true })
        }
        return !!lseAppts

      case BASE.FAVOURITES:
        if (!this.props.features.Favourites)
          this.setState({ showWhyRegisterModal: true })
        return !!this.props.features.Favourites

      case BASE.COMPANY:
      case BASE.PERSON:
        return !!this.props.currentUrl[TAB[key].INDEX]

      case BASE.NEWS_RELEASE:
        if (!lseAppts) {
          this.props.common.setLoginUrl()
          this.setState({ showSubscriptionFeatureModal: true })
        }
        // Permit this page (if content) even if not lseAppts (logged in)
        // because we need to show it via email link
        return !!this.props.currentUrl[TAB[key].INDEX]

      case BASE.DASHBOARD:
        if (!lseAppts) {
          this.props.common.setLoginUrl()
          this.setState({ showSubscriptionFeatureModal: true })
        }
        return !!lseAppts

      default:
        return true
    }
  }

  render() {
    // console.log("props: ", this.props)
    const { currentUrl, features, portrait, tabIndex } = this.props
    const favouritesEnabled = features && features.Favourites
    const lseAppts = features && features.LseAppts

    const disabled = key => {
      switch (key) {
        case BASE.DASHBOARD:
        case BASE.LSE.COMPANIES:
        case BASE.LSE.ROLES:
        case BASE.LSE.PEOPLE:
        case BASE.LSE.ADVISERS:
        case BASE.LSE.NEWS:
          return !lseAppts

        case BASE.PERSON: // NB: disabled if no person selected (ie no person in currentUrl)
        case BASE.COMPANY: // NB: disabled if no company selected (ie no company in currentUrl)
        case BASE.NEWS_RELEASE: // NB: disabled if no news release selected (ie no news release in currentUrl)
          return !!!currentUrl[TAB[key].INDEX]

        case BASE.FAVOURITES:
          return !favouritesEnabled

        default:
          return false
      }
    }

    const visibleTabs = getVisibleTabs(this.effectiveFeatures)

    const tabOptions = visibleTabs.map(tab => ({
      key: tab.key,
      icon: tab.icon,
      image: tab.image,
      label: tab.label(portrait),
      tooltipTitle: tab.tooltipTitle,
      disabled: disabled(tab.key),
      leftLine: tab.leftLine,
    }
    ))

    const visualTabIndex = visibleTabs.findIndex(tab => TAB[tab.key].INDEX === tabIndex)

    return (
      <React.Fragment>
        <Tabs
          options={tabOptions}
          selectedIndex={visualTabIndex >= 0 ? visualTabIndex : 0}
          onChange={index => this.handleTabsChange(index, lseAppts)}
          portrait={portrait}
        />

        <WhyRegisterModal
          open={this.state.showWhyRegisterModal}
          onClose={() => { this.setState({ showWhyRegisterModal: false }) }}
        />

        <SubscriptionFeatureModal
          open={this.state.showSubscriptionFeatureModal}
          onClose={() => { this.setState({ showSubscriptionFeatureModal: false }) }}
        />

        <UnderDevelopmentModal
          show={this.state.showUnderDevelopmentModal}
          onHide={() => {
            this.setState({ showUnderDevelopmentModal: false });
          }}
        />

      </React.Fragment >
    )
  }
}

const mapStateToProps = state => {
  return {
    // app
    features: state.app.features,
    // common
    currentUrl: state.common.currentUrl,
    tabIndex: state.common.tabIndex,
    the350club: state.common.the350club,
    urlTrialCode: state.common.urlTrialCode,
    // search
    previousSearchString: state.search.previousSearchString,
    scope: state.search.scope,
    seed: state.search.seed,
    // user
    portrait: state.user.portrait,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    common: bindActionCreators(commonActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps,)(HomePageTabs)